import { render, staticRenderFns } from "./bankruptReformList.vue?vue&type=template&id=5d0e0948&scoped=true"
import script from "./bankruptReformList.vue?vue&type=script&lang=js"
export * from "./bankruptReformList.vue?vue&type=script&lang=js"
import style0 from "./bankruptReformList.vue?vue&type=style&index=0&id=5d0e0948&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d0e0948",
  null
  
)

export default component.exports